// extracted by mini-css-extract-plugin
export default {"container":"AvatarGroup_container__b3MSq","avatarContainer":"AvatarGroup_avatarContainer__l+p4f"};